import React from 'react';
import { Box, Typography, Card, CardMedia } from '@mui/material';

const highQualitySamples = [
  {
    title: 'Sample 1',
    audio: '/audios/top-audios/8.wav',
  },
  {
    title: 'Sample 2',
    audio: '/audios/top-audios/4.wav',
  },
  {
    title: 'Sample 3',
    audio: '/audios/top-audios/16.wav',
  },
  {
    title: 'Sample 4',
    audio: '/audios/top-audios/def1.wav',
  },
  {
    title: 'Sample 5',
    audio: '/audios/top-audios/c31.wav',
  },
];

function HighQualitySamples() {
  return (
    <Box
      sx={{
        marginTop: '24px',
        marginBottom: '24px',
        padding: '16px',
        display: 'flex',
        justifyContent: 'space-evenly', // Adds even horizontal spacing
        alignItems: 'center',
        flexWrap: 'wrap', // Wrap to the next line
        rowGap: '32px', // Increase vertical spacing between rows
        columnGap: '48px', // Increase horizontal spacing between items
      }}
    >
      {highQualitySamples.map((sample, index) => (
        <Card
          key={index}
          sx={{
            textAlign: 'center',
            padding: '8px',
            borderRadius: '12px',
            boxShadow: 2,
            width: '250px', // Fixed width for consistent alignment
          }}
        >
          <CardMedia
            component="audio"
            src={sample.audio}
            controls
            style={{ width: '100%' }}
          />
          <Typography
            variant="body2"
            sx={{ marginTop: '8px', fontWeight: 'bold' }}
          >
            {sample.title}
          </Typography>
        </Card>
      ))}
    </Box>
  );
}

export default HighQualitySamples;
